import { SerializedStyles, css } from '@core-ui/react-stitch';

const getStyles = (isBananaRepublic = false) : SerializedStyles => css`
  max-width: ${isBananaRepublic ? '800' : '1280'}px;
  padding: 0 1rem;
  display: flex;
  width: 100%;
  margin: 2rem ${isBananaRepublic ? '0' : 'auto'};
`;

export {
  getStyles
};
